export function getOrgInvitationsCacheKey(orgId: string) {
  return ['organization', orgId, 'invitations']
}

export function getProjectInvitationsCacheKey(projectId: string) {
  return ['project', projectId, 'invitations']
}
